
<template>
    <div class="center">
      <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
              <span>Cambiar concepto</span>
          </h4>
        </template>


        <div class="con-form">
                <p class="mb-0"><small>Concepto actual</small></p>
                <p><strong>{{row.concepto}}</strong></p>
                
                <p class="mb-0"><small>Concepto nuevo</small></p>
                <form autocomplete="off" style="width:100%;">
                  <vs-select class="pt-0" filter v-model="concepto"  :key="conceptoId" :disabled="!listConceptos.length">
                    <template #message-danger v-if="errorFields.includes('concepto')">
                      {{ errorFields.includes('concepto') ? 'Requerido' : noConceptos == true ? 'Para este Ciclo escolar no hay reglas de cobro configuradas' : ''}}
                    </template>
                    <template v-if="listConceptos.length">
                      <vs-option v-for="option in listConceptos" :key="option.id" :label="option.nombre" :value="option.id">
                        {{option.nombre}} <span>- $ {{option.monto_cargo}}</span>
                      </vs-option>
                    </template>
                    <template v-else>
                      <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                      </vs-option>
                    </template>
                  </vs-select>
                </form>
        </div>

        <template #footer>
          <div class="footer-dialog" style="display:flex;">  
            <vs-button block danger class="color-red" @click="active = false, concepto = ''">
              Cancelar
            </vs-button>
            <vs-button block success @click="postCambiarConcepto()">
              Aceptar
            </vs-button>        
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import cobranza from '../../../../api/requests/cobranza-persona.js'
import profesor from '../../../../api/requests/landing-profesor'
    export default {
        props:[
        'value',
        'row',
        'cicloEscolar',
        'institucion',
        'personaId',
        'programa',
        'programaId',
        'programas',
        ],
        data:() => ({
            active: false,
            concepto: '',
			      listConceptos: [],
            concepto: '',
            listConceptos: [],
            errorFields:[],
            noConceptos: false,
            conceptoId: (new Date()).getTime()
        }),
        methods:{
            async postCambiarConcepto(){
              const loading = this.$vs.loading()
              try{
                const formData = new FormData()
                formData.append('movimiento_id', this.row.movimiento_id)
                formData.append('codigo_detalle_id', this.concepto)
                const response = await profesor.postCambiarConcepto(formData)
                this.active = false
                this.concepto = ''
                this.$emit('changeConcepto', this.row);
                loading.close()
              }catch(error){
                console.log(error)
                loading.close()
              }
            },
            // async getProgramas () {
            //   console.log("entro cambiar concepto")
            //     if (this.institucion && this.cicloEscolar){
            //     let params = {
            //         institucion_id: this.institucion,
            //         persona_id: this.personaId,
            //         ciclo_escolar_id: this.cicloEscolar,
            //     }
                
            //     const { data: response } = await cobranza.getPrograma(params) || {}
            //     const { opciones: programas, default:val } = response || {}
            //         if (programas){
            //             this.listPrograma = Object.values(programas)
            //             this.programa = val
            //             this.programaDefault = val
            //             this.programaId = (new Date()).getTime()
            //         }
            //     }
            // },
            async getConcepto() {
                if(this.programa !== '' && this.cicloEscolar !== ''){
                  let params = {
                    programa : this.programa,
                    institucion: this.institucion,
                    ciclo_escolar: this.cicloEscolar,
                    tipo: 'abierto',
                    persona: this.personaId,
                    fecha: this.fecha
                  }
                  const response = await cobranza.getConceptos(params) || {}
                  this.listConceptos = response.data

                  if (this.listConceptos && this.listConceptos.length && this.listConceptos.length >0 ){
                    this.noConceptos = false
                  }else {
                    this.noConceptos = true
                  }
                }
              this.conceptoId = (new Date()).getTime()
            },
        },
        watch: {
            value (val) {
                this.active = val
            },
            active (val) {
                if (!val){
                    this.$emit('input', val);
                }
            },
            // cicloEscolar(){
            //   this.getProgramas()
            // },
            programa(){
              this.getConcepto()
            }
        }
    }
</script>
